import { observable, computed, makeObservable, action } from 'mobx';

export type UnionListItemType = {
  name: string;
};

export type UnionListType = {
  id: number;
  title: string;
  unions: UnionListItemType[];
};

class UnionLists {
  @observable currentListUnions: UnionListItemType[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  setCurrentListUnions(unions: UnionListItemType[]) {
    this.currentListUnions = unions;
  }

  @action
  clear() {
    this.currentListUnions = [];
  }

  @computed
  get valuesForDropdown(): Array<{
    key: string;
    label: string;
    value: string;
  }> {
    const sorter = new window.Intl.Collator('sv', { usage: 'sort' });

    const unions = this.currentListUnions.map((union) => ({
      key: union.name,
      label: union.name,
      value: union.name,
    }));

    return unions;
  }
}

export default new UnionLists();
